import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "MainPageBackground" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "TopBarContent" }
const _hoisted_4 = { class: "Logo" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "home-particles" }
const _hoisted_7 = {
  id: "section-1",
  class: "full-page-section content-section"
}
const _hoisted_8 = { class: "decorative-sidebar" }
const _hoisted_9 = { class: "product-left" }
const _hoisted_10 = { class: "product-image-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-right" }
const _hoisted_13 = { class: "game-title" }
const _hoisted_14 = { class: "game-subtitle" }
const _hoisted_15 = { class: "game-desc" }
const _hoisted_16 = { class: "highlight" }
const _hoisted_17 = { class: "game-list-sidebar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "info-boxes-wrapper"
}
const _hoisted_21 = {
  key: 1,
  class: "info-boxes-wrapper empty-announcement"
}
const _hoisted_22 = { class: "about-panel-container" }
const _hoisted_23 = { class: "about-navigation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-num" }
const _hoisted_26 = { class: "card-title-group" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-subtitle" }
const _hoisted_29 = { class: "about-details-content" }
const _hoisted_30 = { class: "viewport-main-title" }
const _hoisted_31 = { class: "row-header" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-description" }
const _hoisted_34 = {
  key: 0,
  class: "all-list-overlay"
}
const _hoisted_35 = { class: "all-list-box" }
const _hoisted_36 = { class: "all-list-scroll" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "simple-info" }

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router"; // ルーターAPIをインポート
import useGlobalStateStore, { Enum_Theme } from "@/Store/GlobalStateStore";
import InfoBox_Left from "@/components/InfoBox_Left.vue";
import AnnouncementModal from "@/components/AnnouncementModal.vue";
import { AnOutlinedBilibili, AnOutlinedX, MdEmail, SiSinaweibo, CoBrandYoutube, AnOutlinedClose } from "@kalimahapps/vue-icons";
import { fetchAnnouncements } from "@/server/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage_JPN',
  setup(__props) {

_useCssVars(_ctx => ({
  "v342929dc": (ThemeTopBarBackgroundColor.value),
  "v416b9f22": (activeSection.value === 0 ? "none" : "0 2px 4px rgba(0, 0, 0, 0.15)"),
  "v03365be0": (ThemeTopBarColor.value),
  "c475d1aa": (ThemeItemColor.value),
  "v7addbc37": (ThemeHintColor.value),
  "v32d17556": (ThemeMainSloganCruxColor.value),
  "cd8940f2": (ThemeMainSloganColor.value),
  "v07839759": (ThemeSubSlogan.value),
  "v6742e61a": (ThemeIconBackgroundHoverColor.value),
  "v26b89535": (ThemeBottomBG.value),
  "v8a810eda": (ThemeBottomPartingLine.value),
  "v33019e8a": (ThemeCopyrightFiling.value)
}))

const GlobalStyleStore = useGlobalStateStore();
const activeSection = ref(0);
const scrollContainer = ref<HTMLElement | null>(null);

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const currentAnnouncementData = ref<any>(null);

function openAnnouncementModal(item: any) {
  currentAnnouncementData.value = item;
  isModalVisible.value = true;

  // ニュースIDをURLに同期する
  router.replace({ query: { ...route.query, news_id: item.id } });
}

function closeAnnouncementModal() {
  isModalVisible.value = false;

  // URLからnews_idパラメータを削除する
  const currentQuery = { ...route.query };
  delete currentQuery.news_id;
  router.replace({ query: currentQuery });
}

const ThemeTopBarBackgroundColor = ref("transparent");
const ThemeTopBarColor = ref("#fff");
const ThemeItemColor = ref("#57E1D9");
const ThemeMainSloganColor = ref("#FFF");
const ThemeMainSloganCruxColor = ref("#57E1D9");
const ThemeSubSlogan = ref("#FFF");
const ThemeIconBackgroundColor = ref("#3fb7b0");
const ThemeIconBackgroundHoverColor = ref("#57E1D9");
const ThemeBottomBG = ref("#242424");
const ThemeBottomPartingLine = ref("#FFFFFF26");
const ThemeCopyrightFiling = ref("#FFF");
const ThemeHintColor = ref("#FFF");

// --- Home 3D Parallax Logic ---
const mouseX = ref(0);
const mouseY = ref(0);
const isHoveringHome = ref(false);

function onHomeMouseMove(e: MouseEvent) {
  isHoveringHome.value = true;
  const { innerWidth, innerHeight } = window;
  mouseX.value = (e.clientX / innerWidth - 0.5) * 2;
  mouseY.value = (e.clientY / innerHeight - 0.5) * 2;
}

function onHomeMouseLeave() {
  isHoveringHome.value = false;
  mouseX.value = 0;
  mouseY.value = 0;
}

const homeBgLayers = computed(() => {
  const moveX = mouseX.value;
  const moveY = mouseY.value;

  const config = [
    { mult: 0.4, scale: 1.02, opacity: 0.35, blur: '6px', blend: 'normal', hue: 0 },
    { mult: 0.8, scale: 1.06, opacity: 0.50, blur: '3px', blend: 'normal', hue: 15 },
    { mult: 1.3, scale: 1.10, opacity: 0.90, blur: '0px', blend: 'normal', hue: 0 },
    { mult: 2.0, scale: 1.16, opacity: 0.40, blur: '2px', blend: 'screen', hue: -15 },
    { mult: 2.8, scale: 1.25, opacity: 0.25, blur: '10px', blend: 'color-dodge', hue: 30 }
  ];

  return config.map((layer, index) => {
    const x = moveX * layer.mult * 1.5;
    const y = moveY * layer.mult * 1.5;
    return {
      transform: `scale(${layer.scale}) translate(${-x}%, ${-y}%)`,
      transition: isHoveringHome.value ? 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'transform 2.5s ease-out',
      backgroundImage: "url('/Images/HomeBG.jpg')",
      opacity: layer.opacity,
      filter: `blur(${layer.blur}) hue-rotate(${layer.hue}deg)`,
      mixBlendMode: layer.blend as any,
      zIndex: index + 1
    };
  });
});

// --- Section 3: "About Us" Data (Japanese Translated) ---
const activeAboutTab = ref(0);
const aboutTabsData = [
  {
    num: "01",
    title: "総則",
    subTitle: "GENERAL",
    paragraphs: [
      { label: "会社案内", desc: "2021年に設立されたLESJEUXA（遊晰概念）は、新世代のゲームクリエイティブ企業です。「技術開発、芸術創造、新文化発信」を理念に掲げ、アジアひいては世界へ向けて、卓越した革新的な「遊晰ソリューション」を提供することに尽力しています。" },
      { label: "宗旨と使命", desc: "宗旨：最先端の科学技術を支えとし、芸術的な創造力を通じて文化の活力を刺激し、ゲーム産業と文化交流のクロスオーバー融合を推進します。\n使命：技術革新によって製品開発を駆動し、芸術的表現を通じて人類の理念を伝え、新しいメディアと多様なプラットフォームを活用して世界的な影響力を持つ新文化を発信します。" },
      { label: "ビジョン", desc: "新しい時代ごとに世界のゲームクリエイティブと文化発信をリードする先駆的企業であり続け、科学技術と芸術の完璧な融合を実現し、オープンで共有・共創的なデジタルエコシステムを構築し、真のメタバースとデジタル生命という人類の夢を実現します。" }
    ]
  },
  {
    num: "02",
    title: "綱領",
    subTitle: "CREED",
    paragraphs: [
      { label: "技術開発", desc: "私たちは科学技術を先導とし、新しい技術と手法を常に模索し、AI、ブロックチェーン、VRなどの分野で突破口を開き、ゲームとメタバースの革新を推進します。研究開発成果の商業化と実用化を重視し、世界中のユーザーに安全でスムーズ、かつ革新的な「遊晰コンセプト」を提供します。" },
      { label: "芸術創造", desc: "私たちは芸術の多様性を尊重し、クリエイティブな潜在能力を刺激し、異分野間の協力を奨励し、伝統文化と現代アート、ゲームデザインの融合を実現します。オリジナリティの精神を堅持し、独自のスタイルを持つゲーム世界と視覚表現を構築し、特別な審美体験を届けます。" },
      { label: "新文化発信", desc: "私たちは開放的で包容力のある姿勢で文化交流を推進し、多様なプラットフォームと形態を通じて、時代精神に合致した新しい文化理念を発信します。デジタルメディアやソーシャルネットワークの力を借りて、世界中のユーザーが質の高い文化コンテンツと革新的な体験を共有できるようにします。" }
    ]
  },
  {
    num: "03",
    title: "実施と管理",
    subTitle: "ACTION",
    paragraphs: [
      { label: "イノベーション駆動", desc: "私たちは学際的・分野横断的なイノベーションチームを立ち上げ、技術と芸術の深い融合を奨励し、未来のトレンドに合致したゲーム製品や文化プロジェクトを作成します。様々な形式のクリエイティブ交流や業界セミナーに熱心に取り組み、メンバー全員の創造力とチームワークの精神を刺激します。" },
      { label: "制度的保障", desc: "当社のプロジェクト管理は、人類の歴史において最も透明性の高いコモン・ロー（普通法）体系に基づいて作成された規則に従って実行されます。効率的かつ規範的な業務遂行を保証するため、開発、創作、発信の完璧な基準を策定します。インセンティブとフィードバックの仕組みを確立し、メンバーが革新し続け、限界を超えるよう促す好循環な企業文化を形成します。" },
      { label: "市場と提携", desc: "私たちは国内外の市場を積極的に開拓・研究し、戦略的パートナーシップを構築し、優れた企業や機関と手を取り合ってゲーム業界2.0に参入します。ブランド構築を重視し、絶え間ない革新と高品質なサービスを通じて、世界のゲーム文化およびメタバース領域におけるLESJEUXAのリーディングイメージを確立します。" }
    ]
  }
];

watch(() => [GlobalStyleStore.CurrentTheme, activeSection.value], () => {
  const isDark = GlobalStyleStore.CurrentTheme === Enum_Theme.Dark;
  const isHome = activeSection.value === 0;

  ThemeTopBarBackgroundColor.value = isHome ? 'transparent' : (isDark ? 'rgba(28, 28, 28, 0.57)' : 'rgba(255, 255, 255, 0.57)');
  ThemeTopBarColor.value = isDark ? '#fff' : '#484848';
  ThemeItemColor.value = isDark ? '#57E1D9' : '#f77373';

  if (isDark) {
    ThemeMainSloganColor.value = '#FFF';
    ThemeMainSloganCruxColor.value = '#57E1D9';
    ThemeSubSlogan.value = '#FFF';
    ThemeIconBackgroundColor.value = '#3fb7b0';
    ThemeIconBackgroundHoverColor.value = '#57E1D9';
    ThemeBottomBG.value = '#242424';
    ThemeBottomPartingLine.value = '#FFFFFF26';
    ThemeCopyrightFiling.value = 'rgba(255,255,255,0.6)';
    ThemeHintColor.value = 'rgba(255,255,255,0.6)';
  } else {
    ThemeMainSloganColor.value = '#545454';
    ThemeMainSloganCruxColor.value = '#f77373';
    ThemeSubSlogan.value = '#1a1a1a';
    ThemeIconBackgroundColor.value = '#de5959';
    ThemeIconBackgroundHoverColor.value = '#f77373';
    ThemeBottomBG.value = '#efefef';
    ThemeBottomPartingLine.value = 'rgba(185,185,185,0.1)';
    ThemeCopyrightFiling.value = 'rgba(0,0,0,0.6)';
    ThemeHintColor.value = 'rgba(0,0,0,0.6)';
  }
}, { immediate: true });

function scrollToSection(index: number) {
  if (scrollContainer.value) {
    const section = scrollContainer.value.querySelector(`#section-${index}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

let observer: IntersectionObserver | null = null;
const allAnnouncements = ref<any[]>([]);
const topAnnouncements = ref<any[]>([]);

onMounted(async () => {
  const options = { root: scrollContainer.value, rootMargin: '0px', threshold: 0.5 };
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idParts = entry.target.id.split('-');
        if (idParts.length === 2) {
          activeSection.value = parseInt(idParts[1]);
        }
      }
    });
  }, options);
  document.querySelectorAll('.full-page-section').forEach(sec => observer?.observe(sec));

  const rawData = await fetchAnnouncements();
  const jaList: any[] = [];

  rawData.forEach((item: any) => {
    try {
      // NOTE: 解析后端 JSON 数据时，提取对应的 .ja 字段
      const titles = item.title.startsWith('{') ? JSON.parse(item.title) : { ja: item.title };
      const summaries = item.summary.startsWith('{') ? JSON.parse(item.summary) : { ja: item.summary };
      const contents = item.content.startsWith('{') ? JSON.parse(item.content) : { ja: item.content };
      const authors = item.author && item.author.startsWith('{') ? JSON.parse(item.author) : { ja: item.author || '' };

      if(titles.ja) {
        jaList.push({
          ...item,
          title: titles.ja,
          summary: summaries.ja || '',
          author: authors.ja || '',
          content: contents.ja || ''
        });
      }
    } catch(error) {
      console.warn("JSON解析失敗、不正なデータの可能性があります", error);
    }
  });

  allAnnouncements.value = jaList;
  topAnnouncements.value = jaList.slice(0, 3);

  // URLパラメータをチェックし、直接ニュースを開く
  const newsId = route.query.news_id;
  if (newsId) {
    const targetNews = allAnnouncements.value.find(item => String(item.id) === String(newsId));
    if (targetNews) {
      // DOMマウント完了を確実にするための遅延後、スクロールしてモーダルを開く
      setTimeout(() => {
        activeSection.value = 2; // ナビゲーションのアクティブ状態を強制
        scrollToSection(2);      // ニュースセクションにスクロール
        openAnnouncementModal(targetNews);
      }, 500);
    }
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const isAllListModalVisible = ref(false);

const gameList = ref([
  {
    id: 1,
    titleCHS: '星夢旅記・域灰の夢',
    titleEN: 'Star Reverie · Greystasis',
    desc: [
      '灰域が広がり、異夢症が猛威を振るう中、人類の安住の地は急速に崩壊しつつある。',
      '主人公は偶然の契機から「ニュクトフォロス」に加わり、執約者となる。仲間と共に危局を救い、他者を助け、自らの生い立ちを追い求める中で、主人公は世界の真実へと静かに近づいていく。',
      'しかし、希望の象徴である「夢の源」さえも深紅に染まり、悪夢が奔流のように現実を飲み込む時、残された時間はわずかとなる。運命と夢を宿す器は砕け散る寸前となり、神の血が遂に現世へと降り注ぐ——'
    ],
    highlight: '再起動か、それとも終焉か。',
    kvPath: '/Images/Games/Star Reverie/StarReverieKV.png',
    iconPath: '/Images/Games/Star Reverie/StarReverieIcon.png'
  }
]);
const currentGameIndex = ref(0);

function OnUserClickLogo() {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark) {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Light);
  } else {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Dark);
  }
}

async function OnCLickEmail() {
  try {
    await navigator.clipboard.writeText("info@lesjeuxa.com");
    alert("メールアドレスをクリップボードにコピーしました。ご連絡をお待ちしております！(๑′ᴗ‵๑)❤");
  } catch (error) {
    console.error("コピー失敗", error);
  }
}

function OnCLickX() {
  window.open("https://x.com", "_blank");
}

function OnCLickWeiBo() {
  window.open("https://weibo.com/", "_blank");
}

function OnCLickBilibili() {
  window.open("https://www.bilibili.com/", "_blank");
}

function OnCLickYoutuber() {
  window.open("https://www.youtube.com/@lesjeuxa", "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Dark)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/Images/Logo.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true),
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Light)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "/Images/Logo_1.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["NavBar", { 'hide-on-home': activeSection.value === 0 }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['ホーム', '製品情報', 'ニュース', '会社概要', '採用情報'], (item, index) => {
            return _createElementVNode("span", {
              key: index,
              class: _normalizeClass(["nav-item", { active: activeSection.value === index }]),
              onClick: ($event: any) => (scrollToSection(index))
            }, _toDisplayString(item), 11, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Login", { 'hide-on-home': activeSection.value === 0 }])
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "item" }, "新規登録", -1),
          _createElementVNode("span", { class: "separator" }, "|", -1),
          _createElementVNode("span", { class: "item" }, "ログイン", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "ScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("section", {
        id: "section-0",
        class: "full-page-section home-section",
        onMousemove: onHomeMouseMove,
        onMouseleave: onHomeMouseLeave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeBgLayers.value, (layerStyle, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "home-parallax-bg",
            style: _normalizeStyle(layerStyle)
          }, null, 4))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "home-vignette-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
            return _createElementVNode("div", {
              class: "particle",
              key: n
            })
          }), 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "overlay",
          style: {"z-index":"10"}
        }, null, -1)),
        _createElementVNode("div", {
          class: "scroll-hint",
          style: {"z-index":"11","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToSection(1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "下にスクロールして詳細を表示", -1),
          _createElementVNode("div", { class: "arrow-down" }, null, -1)
        ]))])
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-container", { 'is-active': activeSection.value === 1 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(gameList.value[currentGameIndex.value].titleEN.toUpperCase()) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _cache[10] || (_cache[10] = _createTextVNode(" LESJEUXA", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock("img", {
                src: gameList.value[currentGameIndex.value].kvPath,
                class: "product-kv",
                key: currentGameIndex.value
              }, null, 8, _hoisted_11))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(gameList.value[currentGameIndex.value].titleCHS), 1),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(gameList.value[currentGameIndex.value].titleEN), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value[currentGameIndex.value].desc, (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(gameList.value[currentGameIndex.value].highlight), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (game, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.id,
                class: _normalizeClass(["game-list-item", { 'is-selected': currentGameIndex.value === index }]),
                onClick: ($event: any) => (currentGameIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: game.iconPath
                }, null, 8, _hoisted_19)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ], 2)
      ]),
      _createElementVNode("section", {
        id: "section-2",
        class: _normalizeClass(["full-page-section content-section", { 'is-active': activeSection.value === 2 }])
      }, [
        (topAnnouncements.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topAnnouncements.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "anim-item",
                  style: _normalizeStyle({ 'transition-delay': `${index * 0.2}s` })
                }, [
                  _createVNode(InfoBox_Left, {
                    Title: item.title,
                    Summary: item.summary,
                    ImagePath: item.cover_image,
                    onOpenModal: ($event: any) => (openAnnouncementModal(item))
                  }, null, 8, ["Title", "Summary", "ImagePath", "onOpenModal"])
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "最新情報はありません", -1)
            ]))])),
        (allAnnouncements.value.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllListModalVisible.value = true))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" More ", -1),
              _createElementVNode("span", null, "+", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        id: "section-3",
        class: _normalizeClass(["full-page-section content-section learn-us-section", { 'is-active': activeSection.value === 3 }])
      }, [
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"about-header-slogan\" data-v-f9f1c322><h1 class=\"brand-core-slogan\" data-v-f9f1c322><span class=\"highlight-cyan\" data-v-f9f1c322>技術</span>開発 • <span class=\"highlight-cyan\" data-v-f9f1c322>芸術</span>創造 • <span class=\"highlight-cyan\" data-v-f9f1c322>新文化</span>発信 </h1><p class=\"brand-core-desc\" data-v-f9f1c322> LESJEUXAは常に最先端技術と芸術的美学の融合に尽力し、デジタル時代に向けて卓越した「遊晰ソリューション」を提供します。 </p></div>", 1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aboutTabsData, (tab, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["about-nav-card", { 'is-active': activeAboutTab.value === index }]),
                onClick: ($event: any) => (activeAboutTab.value = index)
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(tab.num), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(tab.title), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(tab.subTitle), 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-glow-bar" }, null, -1))
              ], 10, _hoisted_24)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createElementBlock("div", {
              class: "details-viewport",
              key: activeAboutTab.value
            }, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString(aboutTabsData[activeAboutTab.value].title) + " 要綱", 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "viewport-divider" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutTabsData[activeAboutTab.value].paragraphs, (para, pIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIdx,
                  class: "content-row",
                  style: _normalizeStyle({ 'animation-delay': `${pIdx * 0.15}s` })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "row-indicator" }, null, -1)),
                    _createElementVNode("h4", _hoisted_32, _toDisplayString(para.label), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(para.desc), 1)
                ], 4))
              }), 128))
            ]))
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        id: "section-4",
        class: "full-page-section end-section"
      }, [
        _createElementVNode("div", { class: "join-content" }, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "join-text-group" }, [
            _createElementVNode("h2", { class: "join-title" }, [
              _createTextVNode("採用情報 / "),
              _createElementVNode("span", { class: "highlight-text" }, "JOIN US")
            ]),
            _createElementVNode("p", { class: "join-subtitle" }, "あなたの才能で、私たちと一緒に次の夢を織り成すことを楽しみにしています。")
          ], -1)),
          _createElementVNode("div", {
            class: "contact-wrapper",
            onClick: OnCLickEmail
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("div", { class: "contact-label" }, "MAIL TO US", -1),
            _createElementVNode("div", { class: "contact-email" }, "info@lesjeuxa.com", -1),
            _createElementVNode("div", { class: "contact-hover-line" }, null, -1),
            _createElementVNode("div", { class: "contact-hint" }, "CLICK TO COPY / クリックしてメールアドレスをコピー", -1)
          ]))])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "BottomBG" }, [
          _createElementVNode("div", { class: "BottomPartingLine" }),
          _createElementVNode("div", { class: "BottomContent" }, [
            _createElementVNode("div", { class: "CopyrightFiling" }, "Copyright 2021-2026 LESJEUXA.COM 遊晰概念有限公司")
          ])
        ], -1))
      ])
    ], 512),
    _createVNode(AnnouncementModal, {
      visible: isModalVisible.value,
      announcement: currentAnnouncementData.value,
      onClose: closeAnnouncementModal
    }, null, 8, ["visible", "announcement"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAllListModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllListModalVisible.value = false))
                }, [
                  _createVNode(_unref(AnOutlinedClose))
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("h2", { style: {"color":"black","margin-bottom":"30px"} }, "すべてのニュース", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAnnouncements.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "simple-list-item",
                      key: item.id,
                      onClick: ($event: any) => (openAnnouncementModal(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.cover_image,
                        class: "slim-cover"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.summary), 1)
                      ])
                    ], 8, _hoisted_37))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "global-scroll-hint",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(activeSection.value + 1)))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("div", { class: "arrow-down" }, null, -1)
    ]))], 512), [
      [_vShow, activeSection.value > 0 && activeSection.value < 4]
    ])
  ]))
}
}

})